/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useMemo, useState } from 'react'
import { useFieldArray } from 'react-hook-form';
import {  numberFormatterLocale, parseFloatCheckValue } from '../../fnTickit';
import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, Grid, Typography, TextField } from '@mui/material';
import InputNumberItem from 'components/Input/InputNumber';
import _ from "lodash";
import { ProviderSoldTicket } from '../../TicketSold/TicketSoldForm';

const TableMoney = () => {
    const {
        isView,
        form,
        option,
        setObjTotalMoney,
    } = useContext(ProviderSoldTicket);

    const { control, watch } = form;

    const { fields } = useFieldArray({
        control,
        name: "lstCurrencyElec"
    });

    const watchFieldArray = watch("lstCurrencyElec");
    const controlledFields = fields.map((field, index) => {
        return {
            ...field,
            ...watchFieldArray[index]
        };
    });

    const [totalAmountTicket, setTotalAmountTicket] = useState(0)
    const [totalAmountElec, setTotalAmountElec] = useState(0)

    const nTotalCurrency = useMemo(() => {
        let total = totalAmountTicket + totalAmountElec;
        return total;
    }, [totalAmountElec, totalAmountTicket])

    const lstCurrencyNotes = useMemo(() => {
        let arrTicket = watch("lstSoldTicket");
        let lstData = [];
        if (arrTicket.length !== 0) {
            lstData = option.lstCurrencyNotes
        }

        return lstData;
    }, [option.lstCurrencyNotes, watch("lstSoldTicket")])

    const lstCurrencyCoins = useMemo(() => {
        let arrTicket = watch("lstSoldTicket");
        let lstData = [];
        if (arrTicket.length !== 0) {
            lstData = option.lstCurrencyCoins
        }
        return lstData;
    }, [option.lstCurrencyCoins, watch("lstSoldTicket")])

    useEffect(() => {
        if (option.lstCurrencyNotes.length > 0 && option.lstCurrencyCoins.length > 0) {
            let sumCoin = _.sumBy(option.lstCurrencyCoins, function (o: any) { return parseFloatCheckValue(o.valueInput) * o.valueLabel; });
            let sumNotes = _.sumBy(option.lstCurrencyNotes, function (o: any) { return parseFloatCheckValue(o.valueInput) * o.valueLabel; });
            let sumCurrency = sumCoin + sumNotes;
            if (setObjTotalMoney) {
                setObjTotalMoney(sumCurrency)
            }
            setTotalAmountTicket(sumCurrency)
        }
    }, [option.lstCurrencyNotes, option.lstCurrencyCoins])

    useEffect(() => {
        if (controlledFields.length > 0) {
            let sumCurrency = _.sumBy(controlledFields, function (o) { return parseFloatCheckValue(o.valueInputDecimal); });
            setTotalAmountElec(sumCurrency)
        }
    }, [controlledFields])

    const handleCalculateCurrency = (value, typeCurrency, index) => {
        let checkValue = value !== "" ? parseFloatCheckValue(value) : null;
        switch (typeCurrency) {
            case "coins":
                lstCurrencyCoins[index].valueInput = checkValue;
                break;
            case "notes":
                lstCurrencyNotes[index].valueInput = checkValue;
                break;
        }
        let sumCoin = _.sumBy(lstCurrencyCoins, function (o) { return parseFloatCheckValue(o.valueInput) * o.valueLabel; });
        let sumNotes = _.sumBy(lstCurrencyNotes, function (o) { return parseFloatCheckValue(o.valueInput) * o.valueLabel; });
        let sumCurrency = sumCoin + sumNotes;
        if (setObjTotalMoney) {
            setObjTotalMoney(sumCurrency)
        }
        setTotalAmountTicket(sumCurrency)
    }

    const handleCalculateElect = (value, index) => {

        controlledFields[index].valueInputDecimal = value !== "" ? parseFloatCheckValue(value) : null;
        let sumCurrency = _.sumBy(controlledFields, function (o) { return parseFloatCheckValue(o.valueInputDecimal); });
        setTotalAmountElec(sumCurrency)
    }

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Typography className="font-weight-500">รายการธนบัตรและเหรียญ ที่จัดเก็บได้</Typography>
            </Grid>
            <Grid item xs={12} md={6}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        {/* ธนบัตร */}
                        <TableContainer id='table-money-notes' component={Paper}>
                            <Table>
                                <TableBody>
                                    <TableRow>
                                        <TableCell
                                            className='bg-color'
                                            padding='none'
                                            rowSpan={2}
                                            style={{ minWidth: '100px', width: '100px', fontSize: '1.2em' }}
                                        >
                                            ธนบัตร
                                        </TableCell>
                                        {
                                            lstCurrencyNotes.map((row, index) => {
                                                return (
                                                    <TableCell
                                                        key={row.value}
                                                        className='bg-color'
                                                        padding='none'
                                                    >
                                                        {row.label}
                                                    </TableCell>
                                                )
                                            })
                                        }
                                    </TableRow>
                                    <TableRow>
                                        {
                                            lstCurrencyNotes.map((row, index) => {
                                                return (
                                                    <TableCell
                                                        key={row.value}
                                                        padding='none'
                                                    >
                                                        <InputNumberItem
                                                            id={`note_${index}`}
                                                            name={`note_${index}`}
                                                            defaultValue={row.valueInput}
                                                            required={false}
                                                            disabled={isView}
                                                            maxDigits={0}
                                                            IsCanMinus={false}
                                                            IsShowMessageError={false}
                                                            onChange={(value) => handleCalculateCurrency(value, "notes", index)}
                                                        />
                                                    </TableCell>
                                                )
                                            })
                                        }
                                    </TableRow>
                                    {
                                        lstCurrencyNotes.length === 0 ?
                                            <TableRow >
                                                <TableCell align="center" >ไม่พบข้อมูล</TableCell>
                                            </TableRow>
                                            :
                                            null
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                    <Grid item xs={12}>
                        {/* เหรียญ */}
                        <TableContainer id='table-money-coins' component={Paper}>
                            <Table>
                                <TableBody>
                                    <TableRow>
                                        <TableCell
                                            className='bg-color'
                                            padding='none'
                                            rowSpan={2}
                                            style={{ minWidth: '100px', width: '100px', fontSize: '1.2em' }}
                                        >
                                            เหรียญ
                                        </TableCell>
                                        {
                                            lstCurrencyCoins.map((row, index) => {
                                                return (
                                                    <TableCell
                                                        key={row.value}
                                                        className='bg-color'
                                                        padding='none'
                                                    >
                                                        {row.label}
                                                    </TableCell>
                                                )
                                            })
                                        }
                                    </TableRow>
                                    <TableRow>
                                        {
                                            lstCurrencyCoins.map((row, index) => {
                                                return (
                                                    <TableCell
                                                        key={row.value}
                                                        padding='none'
                                                    >
                                                        <InputNumberItem
                                                            id={`coin_${index}`}
                                                            name={`coin_${index}`}
                                                            defaultValue={row.valueInput}
                                                            required={false}
                                                            maxDigits={0}
                                                            disabled={isView}
                                                            IsCanMinus={false}
                                                            IsShowMessageError={false}
                                                            onChange={(value) => handleCalculateCurrency(value, "coins", index)}
                                                        />
                                                    </TableCell>
                                                )
                                            })
                                        }
                                    </TableRow>
                                    {
                                        lstCurrencyCoins.length === 0 ?
                                            <TableRow >
                                                <TableCell align="center" >ไม่พบข้อมูล</TableCell>
                                            </TableRow>
                                            :
                                            null
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} md={3}>
                {/* <Typography>คิดเป็นเงิน (บาท)</Typography> */}
                <TableContainer id='table-money-notes' component={Paper}>
                    <Table >
                        <TableBody>
                            <TableRow>
                                <TableCell
                                    padding='none'
                                    className="font-weight-500"
                                >
                                    คิดเป็นเงิน (บาท)
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell
                                    padding='none'
                                    rowSpan={2}
                                >
                                    <TextField
                                        id={"totalAmountTicket"}
                                        name={"totalAmountTicket"}
                                        value={numberFormatterLocale(totalAmountTicket, 2)}
                                        variant={"outlined"}
                                        type={"text"}
                                        size={"small"}
                                        fullWidth={true}
                                        disabled
                                        inputProps={{
                                            style: {
                                                textAlign: "right",
                                            }
                                        }}
                                    />
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
            <Grid item xs={12}>
                <Typography className="font-weight-500">รายการชำระผ่านช่องทางอิเล็กทรอนิกส์</Typography>
            </Grid>
            <Grid item xs={12} md={6}>
                {/* รายการชำระผ่านช่องทางอิเล็กทรอนิกส์ */}
                <TableContainer id='table-receive' component={Paper}>
                    <Table >
                        <TableHead>
                            <TableRow>
                                <TableCell component="th" padding='none' style={{ minWidth: '40px', width: '40px' }}>ที่</TableCell>
                                <TableCell component="th" padding='none' style={{ minWidth: '300px', width: '300px' }}>ประเภทบัตร</TableCell>
                                <TableCell component="th" padding='none' >จำนวนเงิน (บาท)</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                controlledFields.map((row, index) => {
                                    const fieldName = `lstCurrencyElec.${index}`;
                                    return (
                                        <TableRow key={`${fieldName}.sID`}>
                                            <TableCell align="center" >{index + 1}</TableCell>
                                            <TableCell align="left">{row.label}</TableCell>
                                            <TableCell align="right">
                                                <InputNumberItem
                                                    id={`${fieldName}.valueInputDecimal`}
                                                    name={`${fieldName}.valueInputDecimal`}
                                                    defaultValue={row.valueInputDecimal}
                                                    required={false}
                                                    maxDigits={2}
                                                    IsCanMinus={false}
                                                    IsShowMessageError={false}
                                                    disabled={isView}
                                                    onChange={(value) => {
                                                        handleCalculateElect(value, index)
                                                    }}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    )
                                })
                            }
                            {
                                controlledFields.length === 0 ?
                                    <TableRow >
                                        <TableCell align="center" colSpan={3}>ไม่พบข้อมูล</TableCell>
                                    </TableRow>
                                    :
                                    null
                            }
                            <TableRow >
                                <TableCell align="center" component="th" ></TableCell>
                                <TableCell align="center" component="th">รวม</TableCell>
                                <TableCell component="th" className='text-right'>{numberFormatterLocale(totalAmountElec, 2)}  </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
            <Grid item xs={12} md={4}>
                {/* เงินรวมทั้งสิ้น */}
                <TableContainer id='table-money-notes' component={Paper}>
                    <Table >
                        <TableBody>
                            <TableRow>
                                <TableCell
                                    padding='none'
                                    colSpan={3}
                                    className="font-weight-500"
                                >
                                    เงินรวมทั้งสิ้น
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell padding='none' align='center' style={{ minWidth: '70px', width: '70px' }}>จำนวนเงิน </TableCell>
                                <TableCell padding='none' >
                                    <TextField
                                        id={"nTotalCurrency"}
                                        name={"nTotalCurrency"}
                                        value={numberFormatterLocale(nTotalCurrency, 2)}
                                        variant={"outlined"}
                                        type={"text"}
                                        size={"small"}
                                        fullWidth={true}
                                        disabled
                                        inputProps={{
                                            style: {
                                                textAlign: "right",
                                            }
                                        }}
                                    />
                                </TableCell>
                                <TableCell padding='none' align='center' style={{ minWidth: '50px', width: '50px' }}>บาท</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
        </Grid>
    )
}

export default TableMoney
